<template>
  <v-toolbar dense class="toolbar">
    <v-img contain height="40" width="50" position="left" src="../../assets/logo.svg"></v-img>
    <h4 class="toolbar-title">Reporting & Analytics</h4>
    <v-toolbar-items v-if="authenticated">
      <v-btn to="/">Overview</v-btn>
      <v-btn to="/dash">Detailed View</v-btn>
      <v-btn style="background-color: #e84141;" @click="() => $emit('sign-out')">SIGN OUT</v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>
<script>
export default {
  name: 'AppBar',
  props: {
    authenticated: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style scoped>
.toolbar-title {
  position: absolute;
  left: 200px;
}
</style>
